var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkOrdering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.5C14.5 4.55719 14.5 4.08579 14.7929 3.79289C15.0858 3.5 15.5572 3.5 16.5 3.5H19.5C20.4428 3.5 20.9142 3.5 21.2071 3.79289C21.5 4.08579 21.5 4.55719 21.5 5.5V18.5C21.5 19.4428 21.5 19.9142 21.2071 20.2071C20.9142 20.5 20.4428 20.5 19.5 20.5H16.5C15.5572 20.5 15.0858 20.5 14.7929 20.2071C14.5 19.9142 14.5 19.4428 14.5 18.5V5.5Z",
    stroke: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17C16.5 16.7643 16.5 16.6464 16.5732 16.5732C16.6464 16.5 16.7643 16.5 17 16.5H19C19.2357 16.5 19.3536 16.5 19.4268 16.5732C19.5 16.6464 19.5 16.7643 19.5 17V18C19.5 18.2357 19.5 18.3536 19.4268 18.4268C19.3536 18.5 19.2357 18.5 19 18.5H17C16.7643 18.5 16.6464 18.5 16.5732 18.4268C16.5 18.3536 16.5 18.2357 16.5 18V17Z",
    stroke: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.5H19.5",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.5H19.5",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.5H21.5",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3.5H10.5C9.55719 3.5 9.08579 3.5 8.79289 3.79289C8.5 4.08579 8.5 4.55719 8.5 5.5V18.5C8.5 19.4428 8.5 19.9142 8.79289 20.2071C9.08579 20.5 9.55719 20.5 10.5 20.5H18.5",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5H11C10.7643 16.5 10.6464 16.5 10.5732 16.5732C10.5 16.6464 10.5 16.7643 10.5 17V18C10.5 18.2357 10.5 18.3536 10.5732 18.4268C10.6464 18.5 10.7643 18.5 11 18.5H13",
    stroke: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6C10.2239 6 10 6.22386 10 6.5C10 6.77614 10.2239 7 10.5 7V6ZM10.5 7H13V6H10.5V7Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9C10.2239 9 10 9.22386 10 9.5C10 9.77614 10.2239 10 10.5 10V9ZM10.5 10H13V9H10.5V10Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.5H13",
    stroke: "#222222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.5H4.5C3.55719 3.5 3.08579 3.5 2.79289 3.79289C2.5 4.08579 2.5 4.55719 2.5 5.5V18.5C2.5 19.4428 2.5 19.9142 2.79289 20.2071C3.08579 20.5 3.55719 20.5 4.5 20.5H12.5",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5H5C4.7643 16.5 4.64645 16.5 4.57322 16.5732C4.5 16.6464 4.5 16.7643 4.5 17V18C4.5 18.2357 4.5 18.3536 4.57322 18.4268C4.64645 18.5 4.7643 18.5 5 18.5H7",
    stroke: "#222222"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6C4.22386 6 4 6.22386 4 6.5C4 6.77614 4.22386 7 4.5 7V6ZM4.5 7H7V6H4.5V7Z",
    fill: "#222222"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9C4.22386 9 4 9.22386 4 9.5C4 9.77614 4.22386 10 4.5 10V9ZM4.5 10H7V9H4.5V10Z",
    fill: "#222222"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.5H7",
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkOrdering);
export default __webpack_public_path__ + "static/media/bulk-ordering.b374d5ad31158b8f922ff5ccc75d85ec.svg";
export { ForwardRef as ReactComponent };